import { runEditProgramRequestFlow } from '../shared/runEditProgramRequestFlow';
import { toEditChangeDetailsRequest } from './changeDetailsModel';
import { programRequestsApi } from '../api/programRequestsApi';

export const editChangeDetailsFlow = ({
    form,
    details,
    onError,
    api = programRequestsApi,
}) =>
    runEditProgramRequestFlow({
        request: toEditChangeDetailsRequest(form, details),
        onError,
        updateRequest: api.updateChangeDetailsRequest,
    });
